import api from "./api";

let cache = new Map();
const pending = new Map(); // id -> [resolve]
const queue = new Set();
let timer = null;
let cacheKey = "";

function flush() {
  timer = null;
  const ids = [...queue];
  queue.clear();
  if (!ids.length) return;
  api.post("/catalog/providers", { ids })
    .then(({ data }) => {
      const p = data.providers || {};
      ids.forEach((id) => {
        const b = p[id] || [];
        cache.set(id, b);
        (pending.get(id) || []).forEach((res) => res(b));
        pending.delete(id);
      });
    })
    .catch(() => {
      ids.forEach((id) => {
        (pending.get(id) || []).forEach((res) => res([]));
        pending.delete(id);
      });
    });
}

// servicesKey ties the cache to the user's current service selection
export function getBadges(id, servicesKey) {
  if (servicesKey !== cacheKey) { cache = new Map(); cacheKey = servicesKey; }
  if (!id || !servicesKey) return Promise.resolve([]);
  if (cache.has(id)) return Promise.resolve(cache.get(id));
  return new Promise((resolve) => {
    if (!pending.has(id)) pending.set(id, []);
    pending.get(id).push(resolve);
    queue.add(id);
    if (!timer) timer = setTimeout(flush, 60);
  });
}
